module.exports = __webpack_public_path__ + "img/illo_menu_create.36bf1236.png";